$('.send-group-welcome-packet').click(function () {
  const organizationId = $(this).data('id') ?? null;

  openWelcomePacketModal(
    organizationId,
    __('Are you sure you want to send Welcome Packets to all suborganizations and users on file?')
  );
});

$('.send-organization-users-welcome-packet').click(function () {
  const organizationId = $(this).data('id') ?? null;

  openWelcomePacketModal(
    organizationId,
    __('Are you sure you want to send Welcome Packets to all users on file?')
  );
});

function openWelcomePacketModal(organizationId, message) {
  const dialog = bootbox.confirm({
    title: __('Send Welcome Packets'),
    message: message,
    buttons: {
      confirm: {
        label: __('Yes'),
        className: 'btn-primary'
      },
      cancel: {
        label: __('No'),
        className: 'btn-cancel'
      }
    },
    callback(result) {
      const btns = dialog.find('.btn');

      if (result) {
        btns.loading();

        $.post(urlSendGroupWelcomePacket, { id: organizationId }).success(() => {
          toastr.success(__('Welcome packets has been sent'), __('Success'));
          dialog.modal('hide');
        }).always(() => {
          btns.loading('reset');
        });

        return false;
      }
    }
  });
}
